import script from "./ChallengeNotificationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChallengeNotificationModal.vue?vue&type=script&setup=true&lang=js"

import "./ChallengeNotificationModal.vue?vue&type=style&index=0&id=1a1be0af&lang=css"

const __exports__ = script;

export default __exports__